import type * as Flows from './types.no-deps'
import { getAllElements } from './element.no-deps'
import { pipe } from '../../lib/functional/pipe.no-deps'
import { filter, flatten, mapField, uniq } from '../../lib/functional/array.no-deps'
import { isLoopElement, isUnitSelectElement } from './typeGuards.no-deps'
import _ from 'lodash'
import { findAncestors } from '../units/relations.no-deps'
import type { Identifiable } from '../../lib/typeHelpers.no-deps'
import type { AddableUnitType } from '../units/types.no-deps'
import type { ParentIsUserSelectable } from './UnitFilter.no-deps'

export function getUnitTypesInFlow(flow: Flows.Flow, allUnitTypes: Array<Identifiable<AddableUnitType>>) {
    const childUnitTypeIds = pipe(
        flow,
        getAllElements,
        filter(isUnitSelectElement),
        mapField('unitTypes'),
        flatten,
        uniq
    )
    const contentLoopUnitFiltersTypeIds = pipe(
        flow,
        getAllElements,
        filter(isLoopElement),
        mapField('unitFilters'),
        flatten,
        filter((filter): filter is ParentIsUserSelectable => filter.type === 'ParentIsUserSelectable'),
        mapField('unitType'),
        uniq
    )
    const unitTypesLookup = _.keyBy(allUnitTypes, 'id')
    const ancestorIds: number[] = []
    for (const unitTypeId of childUnitTypeIds) {
        if (unitTypesLookup[unitTypeId]) {
            ancestorIds.push(...findAncestors(unitTypesLookup[unitTypeId], unitTypesLookup))
        }
    }

    return pipe([...childUnitTypeIds, ...ancestorIds, ...contentLoopUnitFiltersTypeIds], uniq)
}
